import * as i0 from '@angular/core';
import { Directive, Self, Input, Output, HostListener, Component, ViewEncapsulation, ChangeDetectionStrategy, HostBinding, NgModule } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as i1 from '@angular/forms';
import { trigger, transition, style, animate } from '@angular/animations';

/* tslint:disable */
var State;
(function (State) {
    State[State["firstAttempt"] = 0] = "firstAttempt";
    State[State["confirming"] = 1] = "confirming";
    State[State["confirmed"] = 2] = "confirmed";
})(State || (State = {}));
class ConfirmDirective {
    constructor(elRef, ngControl, renderer) {
        this.ngControl = ngControl;
        this.renderer = renderer;
        // Whether to go to confirmation immediately once the value validates
        // without waiting for a blur event
        this._confirmImmediatelyOnValid = false;
        this.state = State.firstAttempt;
        this.confirming = new BehaviorSubject(false);
        this.confirmationFailed = false;
        this.confirmationFailed$ = new BehaviorSubject(false);
        this.reasonsToIgnoreTab = 0;
        this.refocusing = false;
        this.el = elRef.nativeElement;
    }
    set confirmImmediatelyOnValid(value) { this._confirmImmediatelyOnValid = !!value || value === ''; }
    get confirmImmediatelyOnValid() { return this._confirmImmediatelyOnValid; }
    ngOnInit() {
        // Store last value
        this.lastValue = this.ngControl.value;
        // Hacky, but it's the only thing that works as required
        // and I can't keep investing time on this right now
        this.ngControlChangesSubscription = this.ngControl.valueChanges.subscribe(() => {
            const lastValue = this.ngControl.value;
            setTimeout(() => this.lastValue = lastValue, 100);
        });
    }
    ngOnDestroy() {
        this.ngControlChangesSubscription.unsubscribe();
    }
    inputHandler() {
        this.clearConfirmationFail();
        switch (this.state) {
            case State.confirmed: // The user is typing into the field after confirmation has happened
                if (this.ngControl.value != this.confirmedValue)
                    this.resetWithValue(this.ngControl.value);
                break;
            case State.firstAttempt:
                if (this.confirmImmediatelyOnValid)
                    if (this.ngControl.valid) {
                        this.getConfirmation();
                        this.ignoreTab();
                    }
                break;
        }
    }
    blurHandler(e) {
        if (!this.refocusing) {
            switch (this.state) {
                case State.firstAttempt:
                    if (this.ngControl.valid)
                        this.getConfirmation();
                    break;
                case State.confirming:
                    this.confirmOrReject();
                    break;
            }
        }
        else
            this.focus(true);
    }
    keyUpHandler(e) {
        if (e.key == 'Backspace' && this.state == State.confirming && !this.lastValue)
            this.editFirstAttempt();
        if (e.key == 'Escape' && this.state == State.confirming)
            this.editFirstAttempt();
    }
    keyDownHandler(e) {
        if (e.key == 'Tab' && this.reasonsToIgnoreTab)
            e.preventDefault();
    }
    cutHandler(e) { e.preventDefault(); }
    copyHandler(e) { e.preventDefault(); }
    getConfirmation() {
        this.firstAttempt = this.ngControl.value;
        this.ngControl.control && this.ngControl.control.setValue(null);
        this.ngControl.reset();
        this.state = State.confirming;
        this.confirming.next(true);
        this.focus(true);
    }
    focus(alsoReset) {
        this.refocusing = true;
        setTimeout(() => {
            this.el.focus();
            if (alsoReset)
                this.ngControl.reset();
        }, 0);
        requestAnimationFrame(() => setTimeout(() => this.refocusing = false, 300));
    }
    confirmOrReject() {
        if (this.ngControl.value == this.firstAttempt) {
            this.confirmedValue = this.ngControl.value;
            this.state = State.confirmed;
        }
        else {
            this.restartProcess();
            this.emitConfirmationFailure();
        }
        this.confirming.next(false);
    }
    restartProcess() {
        this.resetWithValue(null);
    }
    editFirstAttempt() {
        this.resetWithValue(this.firstAttempt);
    }
    resetWithValue(value) {
        delete this.confirmedValue;
        this.ngControl.control && this.ngControl.control.setValue(value);
        delete this.firstAttempt;
        if (this.state == State.confirming)
            this.confirming.next(false);
        this.state = State.firstAttempt;
    }
    emitConfirmationFailure() {
        this.confirmationFailed = true;
        this.confirmationFailed$.next(true);
        this.focus(false);
    }
    clearConfirmationFail() {
        if (this.confirmationFailed) {
            this.confirmationFailed = false;
            this.confirmationFailed$.next(false);
        }
    }
    // ignoreTab() function is used to prevent the user from tabbing out of the field when
    // the field is switched to confirmation mode immediately when the value becomes
    // valid.
    ignoreTab() {
        this.reasonsToIgnoreTab++;
        setTimeout(() => this.reasonsToIgnoreTab--, 1000);
    }
}
ConfirmDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: ConfirmDirective, deps: [{ token: i0.ElementRef }, { token: i1.NgControl, self: true }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
ConfirmDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.1.2", type: ConfirmDirective, selector: "[egovConfirm]", inputs: { confirmImmediatelyOnValid: "confirmImmediatelyOnValid" }, outputs: { confirming: "confirming", confirmationFailed$: "confirmationFailed" }, host: { listeners: { "input": "inputHandler()", "blur": "blurHandler($event)", "keyup": "keyUpHandler($event)", "keydown": "keyDownHandler($event)", "cut": "cutHandler($event)", "copy": "copyHandler($event)" } }, exportAs: ["egovConfirm"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: ConfirmDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[egovConfirm]',
                    exportAs: 'egovConfirm',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1.NgControl, decorators: [{
                    type: Self
                }] }, { type: i0.Renderer2 }]; }, propDecorators: { confirmImmediatelyOnValid: [{
                type: Input
            }], confirming: [{
                type: Output
            }], confirmationFailed$: [{
                type: Output,
                args: ['confirmationFailed']
            }], inputHandler: [{
                type: HostListener,
                args: ['input']
            }], blurHandler: [{
                type: HostListener,
                args: ['blur', ['$event']]
            }], keyUpHandler: [{
                type: HostListener,
                args: ['keyup', ['$event']]
            }], keyDownHandler: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], cutHandler: [{
                type: HostListener,
                args: ['cut', ['$event']]
            }], copyHandler: [{
                type: HostListener,
                args: ['copy', ['$event']]
            }] } });

/* tslint:disable */
class ConfirmLabelComponent {
}
ConfirmLabelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: ConfirmLabelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ConfirmLabelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.1.2", type: ConfirmLabelComponent, selector: "egov-confirm-label", host: { properties: { "@inOut": "this.inOut" } }, ngImport: i0, template: "<div class=\"inner\">\n    <ng-content></ng-content>\n</div>\n", styles: ["egov-confirm-label{display:inline-flex;overflow:hidden;flex-direction:row-reverse}egov-confirm-label .inner{white-space:none}\n"], animations: [
        trigger('inOut', [
            transition(':enter', [
                style({ width: '0px' }),
                animate(`.4s cubic-bezier(.6, 0, .1, 1)`, style({ width: '*' }))
            ]),
            transition(':leave', [
                style({ width: '*' }),
                animate(`.4s cubic-bezier(.6, 0, .1, 1)`, style({ width: '0px' }))
            ]),
        ])
    ], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: ConfirmLabelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'egov-confirm-label', encapsulation: ViewEncapsulation.None, animations: [
                        trigger('inOut', [
                            transition(':enter', [
                                style({ width: '0px' }),
                                animate(`.4s cubic-bezier(.6, 0, .1, 1)`, style({ width: '*' }))
                            ]),
                            transition(':leave', [
                                style({ width: '*' }),
                                animate(`.4s cubic-bezier(.6, 0, .1, 1)`, style({ width: '0px' }))
                            ]),
                        ])
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"inner\">\n    <ng-content></ng-content>\n</div>\n", styles: ["egov-confirm-label{display:inline-flex;overflow:hidden;flex-direction:row-reverse}egov-confirm-label .inner{white-space:none}\n"] }]
        }], propDecorators: { inOut: [{
                type: HostBinding,
                args: ['@inOut']
            }] } });

class ConfirmModule {
}
ConfirmModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: ConfirmModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ConfirmModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: ConfirmModule, declarations: [ConfirmDirective,
        ConfirmLabelComponent], exports: [ConfirmDirective,
        ConfirmLabelComponent] });
ConfirmModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: ConfirmModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: ConfirmModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ConfirmDirective,
                        ConfirmLabelComponent,
                    ],
                    exports: [
                        ConfirmDirective,
                        ConfirmLabelComponent,
                    ],
                }]
        }] });

/*
 * Public API Surface of angular-confirm
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ConfirmDirective, ConfirmLabelComponent, ConfirmModule };
